import { z } from 'my-zod'

export const gitHubIssueSchema = z.object({
  affectedUrl: z.string(),
  userName: z.string(),
  userEmail: z.string(),
  detailedDescription: z.string().min(1, 'Please enter a bug description'),
  outfitterName: z.string().optional(),
  outfitterTimezone: z.string().nullish(),
  platform: z.string(),
  debugIds: z.string().array()
})

export type gitHubIssueSchema = z.infer<typeof gitHubIssueSchema>
